import { eq } from "drizzle-orm";
import { counterparties, referralSettings, commissionAccruals } from "@briolin/db";
import type { TestDb } from "@briolin/db/src/testing.js";
import { postDocument, type DocumentMovements } from "../posting.js";

type Db = TestDb;

const DEFAULT_COMMISSION_RATE = 0.2;

export function computeCommission(orderTotalKopecks: number, rate: number): number {
  return Math.round(orderTotalKopecks * rate);
}

export async function resolveCommissionRate(db: Db, barberCounterpartyId: string): Promise<number> {
  const [cp] = await db.select().from(counterparties).where(eq(counterparties.id, barberCounterpartyId));
  if (cp?.commissionRateOverride != null) return Number(cp.commissionRateOverride);
  const [settings] = await db.select().from(referralSettings);
  if (settings) return Number(settings.commissionRate);
  return DEFAULT_COMMISSION_RATE;
}

export function buildCommissionMovements(
  barberCounterpartyId: string, commissionKopecks: number,
): DocumentMovements {
  return { settlement: [{ counterpartyId: barberCounterpartyId, amountDeltaKopecks: -commissionKopecks }] };
}

export async function postCommissionAccrual(db: Db, accrualId: string): Promise<void> {
  const [acc] = await db.select().from(commissionAccruals).where(eq(commissionAccruals.id, accrualId));
  if (!acc) throw new Error(`COMMISSION_ACCRUAL_NOT_FOUND: ${accrualId}`);
  const movements = buildCommissionMovements(acc.barberCounterpartyId, acc.amountKopecks);
  await postDocument(db, { docType: "commission_accrual", docId: acc.id, date: acc.date }, movements);
}
